import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchFromStrapi } from "../api/strapi";
import LazyImage from "./LazyImage";

export default function LatestInsights() {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetchFromStrapi("/ecls");
        const data = res?.data || [];
        setBlogs(data);
      } catch (err) {
        console.error("Error fetching blogs:", err);
      }
    }

    fetchData();
  }, []);

  const getImageUrl = (item) =>
    item?.attributes?.image?.data?.attributes?.url;

  return (
    <section className="container py-5" style={{ marginBottom: 120 }}>
      <div className="mb-2">
        <p
          className="text-uppercase fw-semibold mb-1"
          style={{ fontSize: "0.75rem", letterSpacing: "0.1em", color: "#009EDC" }}
        >
          Innovation in Action
        </p>
        <h2 className="fw-bold display-5 section-text-dark">
          Latest Insights
        </h2>
      </div>

      <p className="lead-dark mb-4">
        Stay updated with the latest trends in technology.
      </p>

      <div className="row g-4">
        {blogs.slice(0, 8).map((item) => (
          <div
            key={item.id}
            className="col-12 col-sm-6 col-lg-3"
          >
            <div className="insight-card h-100 shadow-sm border-0">
              <LazyImage
                src={getImageUrl(item)}
                alt={item.attributes.title}
                className="insight-img"
                objectFit="cover"
              />

              <div className="card-body d-flex flex-column">
                <div className="insight-content">
                  <small className="insight-date">
                    {item.attributes.date}
                  </small>

                  <h6 className="insight-title mb-2">
                    {item.attributes.title}
                  </h6>
                  {/* 
                  <p
                    className="insight-text text-muted mb-3"
                    style={{ fontSize: "0.9rem" }}
                  >
                    {item.attributes.comment}
                  </p> */}

                  <Link
                    to={`/blog/${item.id}`}
                    className="mt-auto text-decoration-underline fw-semibold"
                  >
                    Read more →
                  </Link>
                </div>
              
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="text-end mt-4"> 
        <Link to="/blog" className="text-decoration-underline fw-semibold">
          Get all latest insights
        </Link>
      </div>
    </section>
  );
}
